import { render, staticRenderFns } from "./CurationsTable.vue?vue&type=template&id=4651a869&scoped=true"
import script from "./CurationsTable.vue?vue&type=script&lang=js"
export * from "./CurationsTable.vue?vue&type=script&lang=js"
import style0 from "./CurationsTable.vue?vue&type=style&index=0&id=4651a869&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4651a869",
  null
  
)

export default component.exports